import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import bus from '@/util/useBus'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { useRtfix, isKO, isJA, useSite } from '@/store'
import { Site } from '@/common/const'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const dialogVisible = ref(false) // 是否显示
const store = useStore()
const isSub = store.getters.isSub
const effectList = ref([ // 功能列表
  {
    id: 1,
    text: t('能够在中国找到丰富的供应商')
  },
  {
    id: 2,
    text: t('按照日本质量标准进行检验（隶属于日本公司）')
  },
  {
    id: 3,
    text: t('最低国际运费保证，可运往23个国家/地区')
  },
  {
    id: 4,
    text: t('可靠的支持和即时的客户服务')
  }
])
// 接收membership，显示加入会员弹窗
bus.on('membership', (state: any) => {
  store.dispatch('guide/getGuide', { customerId: store.getters.user?.customerId }).then(() => {
    const membership = store.getters.membership
    const guideStatus = store.state.guide.guideState
    console.log('store.state.guide.guideState', guideStatus['guide-pure-all'])
    // 韩国站特殊处理，因为没有新手引导导致反复弹，用原日本新手引导的弹窗字段控制guide-pure-all 展示隐藏
    if ((state === 'membership-dialog-show') && membership.templateLevel === 0 && ((!guideStatus['guide-pure-all'] && isKO()) || isJA())) {
      dialogVisible.value = true
    }
  })
})
const closeGuide = () => {
  store.dispatch('guide/changeGuideStatus', { key: 'guide-pure-all', value: true })
}

const closeModal = () => {
  closeGuide()
  dialogVisible.value = false
}

const getNoVipTipImage = () => {
  if (isJA()) {
    return 'https://static-jp.theckb.com/static-asset/client/vip/vip_jump.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_ko2.png'
  } else {
    return 'https://theckbstest-oss.theckbs.com/BusinessMarket/member/vip_jump_UkStation.png'
  }
}
const jump = () => {
  closeGuide()
  router.push(useRtfix('VipLevel'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: "420px",
      "custom-class": 'guideOpen guideOpen-' + _unref(useSite)(),
      onClose: closeModal,
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrap",
          style: _normalizeStyle({ backgroundImage: `url(${getNoVipTipImage()})` })
        }, null, 4),
        _createVNode(_component_el_button, {
          class: "btn",
          onClick: jump
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(isSub) ? _unref(t)('查看会员') : _unref(t)('开通会员')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "custom-class"])
  ]))
}
}

})